import * as React from 'react';

import { 
    makeLayout, makeLayoutSlot,
    makeEntry, IdentityComponent, Effects,
    IControllerContext, IPluginContext, ISlotContext, 
} from '../../core/Slot';
import { URISControls, URIControlsToKind } from '../Controls/hkt';


export const URI = 'Form';
export type URI = typeof URI;

declare module '../../core/Slot' {
    interface URItoKind {
        [URI]: {
            slots: {
                label: {
                    innerProps: {
                        isRequired: boolean,
                        labelLocation: 'top' | 'left',
                        onClick: () => void,
                        labelHeight: number,
                        children: React.ReactNode,
                        className?: string,
                    },
                    outerProps: {},
                },
                control: {
                    innerProps: { focused: boolean, className?: string },
                    outerProps: { 
                        target: React.ForwardRefExoticComponent<React.RefAttributes<HTMLElement> & { name: string }>,
                        name: string,
                    } & URIControlsToKind[URISControls],
                },
                notice: {
                    innerProps: {},
                    outerProps: {},
                },
            },
            controllers: {},
            effects: [],
            plugins: {},
        },
    }
}

const SlotContext = React.createContext({} as ISlotContext<URI>);
const ControllerContext = React.createContext({} as IControllerContext<URI>);
const EffectContext = React.createContext({} as Effects<URI>);
const PluginContext = React.createContext({} as IPluginContext<URI>);

const Empty = React.forwardRef<HTMLElement>(() => {
    return null;
});

export const Entry = makeEntry({
    SlotContext,
    ControllerContext,
    EffectContext,
    PluginContext,
    initSlots: {
        label: { 
            props: {
                isRequired: () => false,
                labelLocation: () => 'top' as const,
                onClick: () => () => {},
                labelHeight: () => 40,
                children: () => () => null,
            }, 
            component: IdentityComponent,
        },
        control: {
            props: {
                target: () => Empty,
                focused: () => false,
                name: () => 'empty name',
            },
            component: IdentityComponent,
        },
        notice: {
            props: {},
            component: IdentityComponent,
        }
    },
    initControllers: {},
    initEffect: [],
});

export const Layout = makeLayout(SlotContext);
export const makeSlot = makeLayoutSlot(SlotContext);
